module.exports = __webpack_public_path__ + "static/media/american.9c54fa0e.jpg";